module.exports = __webpack_public_path__ + "assets/img/Grand.193cb317.svg";